/** Page d'origine à retrouver après connexion (posée par AuthGuard dans `location.state.from`). */
export const redirectTarget = (state: unknown): string => {
  const from = (state as { from?: { pathname?: string; search?: string } } | null)?.from;
  return from?.pathname && !['/login', '/logout', '/set-password'].includes(from.pathname)
    ? `${from.pathname}${from.search || ''}`
    : '/';
};

export const PASSWORD_MIN_LENGTH = 10;

/** Score indicatif de 0 à 4 (longueur + variété des caractères). */
export const passwordStrength = (pw: string): number => {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= PASSWORD_MIN_LENGTH) score += 1;
  if (pw.length >= 14) score += 1;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score += 1;
  if (/\d/.test(pw) && /[^A-Za-z0-9]/.test(pw)) score += 1;
  return pw.length < PASSWORD_MIN_LENGTH ? Math.min(score, 1) : score;
};
